// extracted by mini-css-extract-plugin
export default {"modalBody":"createOrEditRatioModal_modalBody__ix85V"};